export default __webpack_public_path__ + "static/media/Menu.d7600d86.svg";